import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { request } from '../../xhr';
import { getSearchQuery } from '../selectors';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
export function fakeResponse(_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        var Chance = require('chance').Chance; // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        var offset = params.offset, limit = params.limit;
        var randomDeviations = new Chance().pickset(deviationsByType.image, limit);
        return {
            hasMore: offset + limit < deviationsByType.image.length,
            nextOffset: offset + limit,
            results: randomDeviations,
        };
    }
}
function fetch(url, params) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: url,
                    params: params,
                }, fakeResponse)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}
function handleDeviationStreamFetch(action) {
    var streamId, _a, offset, limit, searchQuery, params, response, hasMore, results, normalized;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                streamId = action.streamId;
                return [4 /*yield*/, select(function (state) { return ({
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                        searchQuery: getSearchQuery(state),
                    }); })];
            case 1:
                _a = _d.sent(), offset = _a.offset, limit = _a.limit, searchQuery = _a.searchQuery;
                params = {
                    include_scraps: true,
                    q: searchQuery || undefined,
                    offset: offset,
                    limit: limit,
                };
                return [4 /*yield*/, call(fetch, 'deviation/search', params)];
            case 2:
                response = _d.sent();
                if (!!response) return [3 /*break*/, 4];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch',
                    }))];
            case 3:
                _d.sent();
                return [2 /*return*/];
            case 4:
                hasMore = response.hasMore, results = response.results;
                normalized = results && normalizeDeviations(results);
                return [4 /*yield*/, put(withOffset.actions.fetchSuccess({
                        streamId: streamId,
                        hasMore: results ? !!hasMore : false,
                        items: (_b = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _b !== void 0 ? _b : [],
                        entities: (_c = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _c !== void 0 ? _c : {},
                    }))];
            case 5:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export default handleDeviationStreamFetch;
//# sourceMappingURL=browseDeviationStreamFetch.js.map